import { StytchProvider } from "@stytch/react";
import { appStytchClient } from "app/AppStytchClient";
import { AppConfig } from "shared/config/AppConfig";

export const AppStytchProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) =>
  AppConfig.stytch ? (
    <StytchProvider stytch={appStytchClient}>{children}</StytchProvider>
  ) : (
    children
  );
